export default __webpack_public_path__ + "static/1274-f1ee18daea1957c04a70da920632ad64.gif";